export const doesTokenExist = (token) => token !== '' && token !== undefined
